import { render, staticRenderFns } from "./CompraPrevisaoEntrega.vue?vue&type=template&id=60d7b47e&"
import script from "./CompraPrevisaoEntrega.vue?vue&type=script&lang=js&"
export * from "./CompraPrevisaoEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VEditDialog})
